export const DATE_FORMAT: string = "DD/MM/YYYY";
export const TIME_FORMAT: string = "HH:mm";
export const DATETIME_FORMAT: string = "DD/MM/YYYY HH:mm";
export const enableSidebar = ["/virtual"];
export const enableSidebarButton = [
  // "/virtual",
  "/account/personal-data",
  "/account/verify-account",
  "/account/messages",
  "/account/deposit",
  "/account/withdrawal",
  "/account/movements-list",
  "/account/balance",
  "/account/pendingwithdrawals",
  // "/playsrvirtual"
];
export const backgroundLight = "#dddddd";
export const backgroundDark = " #4d4d4d";
export const primaryColor = " #12324a";
export const secondaryColor = " #0f4b7a";
export const thirdColor = " #2f6188";
export const forthiColor = " #275172";
export const buttonDefault = " #0099bc";
